import { render, staticRenderFns } from "./CarouselDefault.vue?vue&type=template&id=30351328"
import script from "./CarouselDefault.vue?vue&type=script&lang=js"
export * from "./CarouselDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports